import React from "react";
import "./spinner.css";

export default function Spinner() {
  return (
    <div className="center">
      <i className="fa fa-spinner fa-pulse fa-2x fa-fw" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Datatable/spinner/spinner.jsx